import { createContext, useContext, useState, useEffect } from "react";

const DarkModeContext = createContext();

export function DarkModeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    try { return localStorage.getItem("hc-dark-mode") === "true"; } catch { return false; }
  });

  useEffect(() => {
    localStorage.setItem("hc-dark-mode", dark);
    document.documentElement.classList.toggle("hc-dark", dark);
  }, [dark]);

  // Unregister any stale service workers
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((r) => r.unregister());
      });
    }
  }, []);

  return (
    <DarkModeContext.Provider value={{ dark, toggle: () => setDark(p => !p) }}>
      {children}
    </DarkModeContext.Provider>
  );
}

export function useDarkMode() {
  return useContext(DarkModeContext);
}
